import React from 'react';
import './Terminal.css'
import TerminalImg from '../../Assets/Imgs/Terminal.png'

const Terminal = (props) => {
    return ( 
        <div className={props.TerminalStyle} onClick={props.onClick}>
            <img src={props.TerminalImg} alt="Hacking Interface Console" />
        </div>
     );
}
 
export default Terminal;